import { render, staticRenderFns } from "./Tel.vue?vue&type=template&id=0556ce59&scoped=true&"
import script from "./Tel.vue?vue&type=script&lang=js&"
export * from "./Tel.vue?vue&type=script&lang=js&"
import style0 from "./Tel.vue?vue&type=style&index=0&id=0556ce59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0556ce59",
  null
  
)

export default component.exports